import { PureComponent } from 'react';
import { node } from 'prop-types';

class ScrollToTopOnMount extends PureComponent {
    componentDidMount() {
        if (typeof window !== 'undefined' && window.scrollTo) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children || null;
    }
}

ScrollToTopOnMount.propTypes = {
    children: node,
};

export default ScrollToTopOnMount;
